export default "__VITE_ASSET__DFe5HLWr__"